<template>
  <!-- 人身险报表 -->
  <div class="wrapper main-container">
    <div class="content">
      <div class="search-box one-btn min">
        <div class="input-item">
          <span class="label">查询时间</span>
          <DatePicker
            type="month"
            split-panels
            separator="至"
            v-model="searchParams.date"
            placeholder="选择日期"
            :clearable='false'
          ></DatePicker>
        </div>

        <div class="input-item">
          <span class="label">分支机构</span>
          <Select v-model="searchParams.orgId" clearable>
            <Option :value="item.id" v-for="item in orgList" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </div>

        <div class="btn-item">
          <Button type="primary" @click="getTreeTableColmusRow">查询</Button>
          <Button type="primary" ghost @click="exportExcel()" v-show="$units.pointAction('chatManage_11_1')">导出</Button>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <div class="table-container">
      <div class="table-title">
        保险经纪机构业务报表——财产险业务（单位：万元）
      </div>

      <Table
        row-key="id"
        no-filtered-data-text=""
        :columns="columns"
        :data="data"        
        :loading='isLoading'
        id="exportTable"
      >
      </Table>
    </div>
  </div>
</template>

<script>
import { pageTool } from "@/api/mixins";
import { columns } from "./insurancePropertyColumns";
import filters from "@/api/filter";
import FileSaver from 'file-saver';

export default {
  mixins: [pageTool],
  data() {
    return {
      selectTreeId: "",
      columns,
      orgList: [],
      data: [],
      isLoading:false
    };
  },
  activated(){
    this.getTreeTableColmusRow();
    this.getBranch();
  },
  mounted() {
    this.searchParams.date = new Date();
  },

  methods: {
    paramSet(obj) {
      const time = obj.date;
      return {
        orgId: obj.orgId,
        yearNo: time && time.getFullYear().toString(),
        monthNo: time && (time.getMonth() + 1).toString().padStart(2, 0),
        subdivisionType: 101,
      };
    },

    // 分支机构
    getBranch() {
      this.$http({
        url: "/buz/organizationBase/querySub",
        type: "GET",
      }).then((res) => {
        this.orgList = res.data;
      });
    },

    // 获取表格列-行
    getTreeTableColmusRow() {
      this.isLoading = true;
      this.$http({
        url: "/buz/insuranceRegulatory/queryResult",  
        type: "POST",
        data: this.paramSet(this.searchParams),
        apiPermissionCode:'chatManage_11_0'
      }).then((res) => {        
        const data = res.data.insuranceReportDTOS;
        const treeData = [res.data.treeVO];
        let newArr = [];
      
        if(data.length){
          data.map(item=>{
            filters.treeFlatArr(treeData).map(v=>{
              if(item.type == v.id){
                // 年度累计
                v.annual_firstCommissionPrice = item.insuranceReportStatic.annual.firstCommissionPrice;//经纪费用
                v.annual_firstFee = item.insuranceReportStatic.annual.firstFee;//新单保费金额
                v.annual_payable = item.insuranceReportStatic.annual.payable;//应付保费

                // 自营网络平台
                v.selfSupport_firstCommissionPrice = item.insuranceReportStatic.selfSupport.firstCommissionPrice;
                v.selfSupport_firstFee = item.insuranceReportStatic.selfSupport.firstFee;

                // 第三方网络平台
                v.thirdParty_firstCommissionPrice = item.insuranceReportStatic.thirdParty.firstCommissionPrice;
                v.thirdParty_firstFee = item.insuranceReportStatic.thirdParty.firstFee;
                v.flag =  true
              }
              newArr.push(v);
            })
          })
          newArr = this.unique(newArr);
          newArr = filters.handleTree(newArr);
          this.data = this.recursionTree(newArr);
        }else{
          this.data = this.recursionTree(treeData);
        }
        this.isLoading = false;
      }).catch(e => {
        this.isLoading = false;
      });
    },

    // 递归处理行添加表格并排序
    recursionTree(data) {
      return data.map(item=>{
        return {
          ...item,
          children:item.children&&item.children.length?this.recursionTree(item.children).sort((pre, cur)=>pre.id - cur.id):null,
          _showChildren:item.children&&item.children.length?true:false
        }
      })
    },

    // 数组去重
    unique(arr) {
      // 缓存用于记录
      let cache = [];
      for (const t of arr) {
        // 检查缓存中是否已经存在
        if (cache.find(c => c.id == t.id && !t.flag)) {
            // 已经存在说明以前记录过，现在这个就是多余的，直接忽略
            continue;
        }
        // 不存在就说明以前没遇到过，把它记录下来
        cache.push(t);
      }

      // 通过倒叙先去除掉相同id且不符合值的对象
      cache.reverse();

      // 再次进行去除
      var obj = {};
      cache = cache.reduce(function (item, next) {
        obj[next.id] ? '' : obj[next.id] = true && item.push(next);
        return item;
      }, []);
      return cache;
    },

    // 导出
    exportExcel() {
      const XLSX = require('xlsx');
      // 使用 this.$nextTick 是在dom元素都渲染完成之后再执行
      this.$nextTick( ()=> {
        // 设置导出的内容是否只做解析，不进行格式转换     false：要解析， true:不解析
        const xlsxParam = { raw: true }
        const wb = XLSX.utils.table_to_book(document.querySelector('#exportTable'), xlsxParam)
        // 导出excel文件名
        let fileName = filters.filterTime(this.searchParams.date, 'YYYY-MM') + '-财产险业务报表' + '.xlsx'
        const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
        try {
          // 下载保存文件
          FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), fileName)
        } catch (e) {
          if (typeof console !== 'undefined') {
            console.log(e, wbout)
          }
        }
        return wbout
      })   
    },
  },
};
</script>

<style lang="scss" scoped>
.table-container {
  .table-title {
    height: 48px;
    border: 1px solid #e9e9e9;
    border-bottom: none;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f0f0;
    color: #3c464f;
    font-weight: bold;
    font-size: 18px;
  }
}
.content {
  .search-box {
    .input-item {
      .label {
        font-size: 13px;
      }
      /deep/ .ivu-select-selected-value {
        font-size: 13px;
      }
      /deep/ .ivu-input {
        font-size: 13px;
      }
    }
    .btn-item {
      /deep/ .ivu-btn {
        font-size: 13px;
      }
    }
  }
}
/deep/ [data-v-18d2ac93] .ivu-table tr th {
  text-align: center;
}
</style>